import { get, post } from '@/common/utils/request';
import type { ApiResponse } from '@/types/types';
import {
    MerchantPlantformBasicQuery,
    BaseResponseMerchantShopInfoVO,
    BaseResponseMerchantAccountInfo
} from '@/common/types/open.mall.mall-merchant-items';

export const getMerchantInfo = () => {
    return get<ApiResponse<any>>('/mall-merchant-portal/user/info');
};

/**
 * No description
 *
 * @tags 商家维度-相关接口
 * @name GetMerchantShopInfoUsingPost
 * @summary 查看商家店铺基础信息
 * @request POST:/mall-merchant-items/merchant/getMerchantShopInfo
 */
export const getMerchantShopInfo = (params?: MerchantPlantformBasicQuery) =>
    post<BaseResponseMerchantShopInfoVO>('/mall-merchant-items/merchant/getMerchantShopInfo', params);

/**
 * No description
 *
 * @tags 商家维度-相关接口
 * @name QueryMerchantAccountInfoUsingGet
 * @summary 查询商家主账号和经营内容账号-
 * @request GET:/mall-merchant-items/merchant/queryMerchantAccountInfo
 */
export const getMerchantAccountInfo = () => {
    return get<BaseResponseMerchantAccountInfo>('/mall-merchant-items/merchant/queryMerchantAccountInfo');
};
